import { CART_EVENTS } from "@app/lib/events";
import Alpine from "alpinejs";

type MapppedVariant = {
  id: string;
  quantity: number;
  available: boolean;
  size: string;
  hasBackInStock: boolean;
  hasOnlineStock: boolean;
  membershipPrice: string;
};

Alpine.data("variantSelector", (initialVariantId: string) => {
  return {
    selectedVariantId: initialVariantId,
    mappedVariants: [] as MapppedVariant[],

    hasStock: true,
    hasBackInStock: true,
    hasOnlineStock: true,

    handleSelectVariant(event: CustomEvent) {
      this.selectedVariantId = event.detail;
    },

    init() {
      document.addEventListener(CART_EVENTS.SELECT_VARIANT, this.handleSelectVariant.bind(this));
      Alpine.bind(this.$root, this.root);
      this.$watch("mappedVariants", (value) => {
        if (!value) return;

        const params = new URLSearchParams(window.location.search);
        const size = params.get("size");
        if (!size) return;

        const variant = value.find((variant) => variant.size === size);
        if (!variant) return;

        this.selectedVariantId = variant?.id ?? this.selectedVariantId;
      });
    },

    get selectedVariant() {
      return this.mappedVariants.find((variant) => variant.id === this.selectedVariantId);
    },

    root: {
      ["x-effect"]() {
        const variant = this.mappedVariants.find((variant) => variant.id === this.selectedVariantId);

        this.hasStock = variant?.available ?? true;
        this.hasBackInStock = variant?.hasBackInStock ?? true;
        this.hasOnlineStock = variant?.hasOnlineStock ?? true;
        document.dispatchEvent(new CustomEvent(CART_EVENTS.SELECT_VARIANT, { detail: this.selectedVariantId }));
      },
    },

    variant: {
      [":data-ui"]() {
        const variantId = this.$el.value;
        const variant = this.mappedVariants.find((variant) => variant.id === variantId);
        if (!variant) return "hidden";
        if (!variant.available) return "oos";
      },
      ["x-model"]() {
        return "selectedVariantId";
      },
      [":checked"]() {
        return this.selectedVariantId === this.$el.value;
      },
    },

    variantData: {
      ["x-init"]() {
        const content = this.$el.innerHTML;
        this.mappedVariants = JSON.parse(content) as MapppedVariant[];
      },
    },
  };
});
